import { Box, LinearProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

const LOADING_MESSAGES = [
  "Almost there. We're doing the boring bits so you can get on with the fun stuff.",
  "Please be patient while we hunt down the latest version. No, the latest latest version.",
  "One moment. We're coordinating agencies, media owners, creatives and clients. What could possibly go wrong?",
  "Please be patient while we calculate how many spreadsheets you've avoided opening today.",
  "Good things come to those who wait.",
  "Great things come to those who wait for loading bars.",
] as const;

const MESSAGE_ROTATION_MS = 10_000;

const pickRandomLoadingMessage = (exclude?: string): string => {
  const candidates = exclude
    ? LOADING_MESSAGES.filter((message) => message !== exclude)
    : LOADING_MESSAGES;

  return candidates[Math.floor(Math.random() * candidates.length)];
};

export const ProgressFallback = () => {
  const [message, setMessage] = useState(pickRandomLoadingMessage);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setMessage((currentMessage) => pickRandomLoadingMessage(currentMessage));
    }, MESSAGE_ROTATION_MS);

    return () => window.clearInterval(intervalId);
  }, []);

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
        minHeight: "100%",
        padding: 3,
        gap: 2,
      }}
    >
      <Box width={400}>
        <LinearProgress />
      </Box>
      <Typography
        variant="body2"
        color="text.secondary"
        align="center"
        sx={{ maxWidth: 400 }}
      >
        {message}
      </Typography>
    </Box>
  );
};
